export const DOWNLOAD_ALL_RELATIVE_URL_TEMPLATE: string =
    'service.svc/s/GetAllAttachmentsAsZip?id=';
